import { createAction } from 'redux-act';

import { IProspects } from '../requiredActions/requiredActions.types';
import { IVerifiedShippingValidation } from '../shipping/shipping.types';
import { IProduct } from '../../types/Product.types';
import { ISlot } from '../meeting/meeting.types';
import { TFullRecipient } from '../../../../store/users/users.types';

import { IGiftFlowStatusesParams } from './giftFlow.helpers';

const PREFIX = 'RECIPIENT/GIFT_FLOW';

export const setActiveStatus = createAction<number>(`${PREFIX}/SET_ACTIVE_STATUS`);
export const provideStatuses = createAction<IGiftFlowStatusesParams>(`${PREFIX}/PROVIDE_STATUSES`);
export const setRecipient = createAction<TFullRecipient>(`${PREFIX}/SET_RECIPIENT`);
export const setTimezone = createAction<string>(`${PREFIX}/SET_TIMEZONE`);
export const setProspects = createAction<IProspects>(`${PREFIX}/SET_PROSPECTS`);
export const setShippingAddress = createAction<IVerifiedShippingValidation | null>(`${PREFIX}/SET_SHIPPING_ADDRESS`);
export const setProduct = createAction<IProduct>(`${PREFIX}/SET_PRODUCT`);
export const setIsDonation = createAction<boolean>(`${PREFIX}/SET_IS_DONATION`);
export const setCountryId = createAction<number>(`${PREFIX}/SET_COUNTRY_ID`);
export const setConfirmedFlow = createAction<boolean>(`${PREFIX}/SET_CONFIRMED_FLOW`);
export const resetFlow = createAction<void>(`${PREFIX}/RESET_FLOW`);
export const setCalendarPeriod = createAction<{ to: string; from: string }>(`${PREFIX}/SET_CALENDAR_PERIOD`);
export const setMeetingSlots = createAction<ISlot[]>(`${PREFIX}/SET_MEETING_SLOTS`);
export const setMeetingNotes = createAction<string>(`${PREFIX}/SET_MEETING_NOTES`);
export const setHashId = createAction<string>(`${PREFIX}/SET_HASH_ID`);
